import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=1e778b6c&scoped=true"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"
import style1 from "./CreateCustomer.vue?vue&type=style&index=1&id=1e778b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e778b6c",
  null
  
)

export default component.exports